const DAY_MAP = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
const toMin = (t) => {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export const parisNow = () => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Europe/Paris",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  return { day: DAY_MAP[get("weekday")] ?? 0, minutes: Number(get("hour")) * 60 + Number(get("minute")) };
};

export const isOpenNow = (hours = []) => {
  const { day, minutes } = parisNow();
  const today = hours.find((h) => h.day === day);
  return (today?.slots ?? []).some(([a, b]) => minutes >= toMin(a) && minutes < toMin(b));
};

export const formatTime = (t) => {
  const [h, m] = t.split(":");
  return m === "00" ? `${Number(h)} h` : `${Number(h)} h ${m}`;
};

export const formatSlots = (slots = []) =>
  slots.length ? slots.map(([a, b]) => `${formatTime(a)} – ${formatTime(b)}`).join(" · ") : "Fermé";

export const summarizeHours = (hours = []) => {
  const groups = [];
  hours.forEach((h) => {
    const text = formatSlots(h.slots);
    const g = groups[groups.length - 1];
    if (g && g.text === text) g.last = h.label;
    else groups.push({ first: h.label, last: h.label, text });
  });
  return groups.map((g) => ({ days: g.first === g.last ? g.first : `${g.first} – ${g.last}`, text: g.text }));
};
